import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import FormulaService from "../../services/formulaService";
import { handleApiError } from "../../api/handleApiError";

export const fetchAllFormulas = createAsyncThunk(
  "formula/fetchAllFormulas",
  async (params, thunkAPI) => {
    try {
      const res = await FormulaService.getAllFormulas(params);
      return res.data;
    } catch {
      return thunkAPI.rejectWithValue("fetch All Formulas Error");
    }
  }
);

export const fetchFormulaById = createAsyncThunk(
  "formula/getFormulaById",
  async (Id, thunkAPI) => {
    try {
      const res = await FormulaService.getFormulaById(Id);
      return res.data.data;
    } catch {
      return thunkAPI.rejectWithValue("fetch Formula By Id Error");
    }
  }
);

export const createFormula = createAsyncThunk(
  "formula/createFormula",
  async (data, thunkAPI) => {
    try {
      const res = await FormulaService.createFormula(data);
      return res.data.data;
    } catch (e) {
      return handleApiError(e, thunkAPI, "create formula error");
    }
  }
);

export const updateFormula = createAsyncThunk(
  "formula/updateFormula",
  async ({id, data}, thunkAPI) => {
    try {
      const res = await FormulaService.updateFormula(id, data);
      return res.data.data;
    } catch (e) {
      return handleApiError(e, thunkAPI, "Update formula error");
    }
  }
);

export const deleteFormula = createAsyncThunk(
  "formula/deleteFormula",
  async (id, thunkAPI) => {
    try {
      await FormulaService.deleteFormula(id);
      return id;
    } catch (e) {
      return handleApiError(e, thunkAPI, "delete formula error");
    }
  }
);

const formulaSlice = createSlice({
  name: "formula",
  initialState: {
    formulaList: [],
    selectedFormula: null,
    totalRecords: 0,
    loading: false,
    error: null,
    isSuccess: false,
    errorMessage: null,
  },
  reducers: {
    resetStatus: (state) => {
      state.isSuccess = false;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchAllFormulas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllFormulas.fulfilled, (state, action) => {
        state.loading = false;
        state.formulaList = action.payload.data || [];
        state.totalRecords = action.payload.totalRecord;
      })
      .addCase(fetchAllFormulas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch By ID
      .addCase(fetchFormulaById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFormulaById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedFormula = action.payload;
      })
      .addCase(fetchFormulaById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create
      .addCase(createFormula.pending, (state) => {
        state.loading = true;
        state.isSuccess = false;
        state.errorMessage = null;
      })
      .addCase(createFormula.fulfilled, (state, action) => {
        state.loading = false;
        state.isSuccess = true;
        if (action.payload) state.formulaList.push(action.payload);
      })
      .addCase(createFormula.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      })

      // Update
      .addCase(updateFormula.pending, (state) => {
        state.loading = true;
        state.isSuccess = false;
        state.errorMessage = null;
      })
      .addCase(updateFormula.fulfilled, (state, action) => {
        state.loading = false;
        state.isSuccess = true;
        const index = state.formulaList.findIndex((item) => item.id === action.payload?.id);
        if (index !== -1) {
          state.formulaList[index] = action.payload;
        }
      })
      .addCase(updateFormula.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      })

      // Delete
      .addCase(deleteFormula.fulfilled, (state, action) => {
        state.loading = false;
        state.formulaList = state.formulaList.filter((item) => item.id !== action.payload);
      });
  },
});

export const { resetStatus } = formulaSlice.actions;

export default formulaSlice.reducer;
